export const typeGant = [
  { value: 'material', label: 'Материалы', color: '#35bd4b', colorPercent: '#178028' },
  { value: 'work', label: 'Работа', color: '#909bd7', colorPercent: '#3f51b5' },
  { value: 'textField', label: 'Текстовое поле', color: '#ffda00', colorPercent: '#e2b200' },
  { value: 'parent', label: 'Группа', color: '#8c8c8c', colorPercent: '#e2b200' },
  { value: 'milestone', label: 'Веха', color: '#ff8000', colorPercent: '#ff8000' },
  { value: 'link', label: 'Ссылка', color: '#ff0000', colorPercent: '#e20000' },
]